import { DashboardHeader } from '@/components/dashboard/dashboard-header'
import { DashboardShell } from '@/components/dashboard/dashboard-shell'
import { Button } from '@/components/ui/button'
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'
import { Separator } from '@/components/ui/separator'
import { createFileRoute, Link } from '@tanstack/react-router'

export const Route = createFileRoute('/dashboard/admin/role_permissions/')({
  component: RouteComponent,
})

function RouteComponent() {
  return (
    <DashboardShell>
      <DashboardHeader
        heading="Role Permissions"
        text="Choose a role to configure. To save your updates, scroll to the bottom of the settings page, then click Save"
      />
      <Separator />
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mt-4">
        <Card>
          <CardHeader>
            <CardTitle>Admin</CardTitle>
          </CardHeader>
          <CardContent>
            <Link to="/dashboard/admin/role_permissions/admin">
              <Button className="w-full">Configure</Button>
            </Link>
          </CardContent>
        </Card>
        <Card>
          <CardHeader>
            <CardTitle>HR Admin</CardTitle>
          </CardHeader>
          <CardContent>
            <Link to="/dashboard/admin/role_permissions/hr-admin">
              <Button className="w-full">Configure</Button>
            </Link>
          </CardContent>
        </Card>
        <Card>
          <CardHeader>
            <CardTitle>HR Recruitment</CardTitle>
          </CardHeader>
          <CardContent>
            <Link to="/dashboard/admin/role_permissions/hr-recruitment">
              <Button disabled className="w-full">
                Configure
              </Button>
            </Link>
          </CardContent>
        </Card>
        <Card>
          <CardHeader>
            <CardTitle>Employee</CardTitle>
          </CardHeader>
          <CardContent>
            <Link to="/dashboard/admin/role_permissions/employee">
              <Button className="w-full">Configure</Button>
            </Link>
          </CardContent>
        </Card>
        <Card>
          <CardHeader>
            <CardTitle>Supervisor</CardTitle>
          </CardHeader>
          <CardContent>
            <Link to="/dashboard/admin/role_permissions/supervisor">
              <Button className="w-full">Configure</Button>
            </Link>
          </CardContent>
        </Card>
      </div>
    </DashboardShell>
  )
}
